import { render, staticRenderFns } from "./ChatsFavorite.vue?vue&type=template&id=c11dd220&scoped=true&"
import script from "./ChatsFavorite.vue?vue&type=script&lang=js&"
export * from "./ChatsFavorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11dd220",
  null
  
)

export default component.exports